<template>
    <div v-if="activeSite">
        <div id="latest-news-digest" v-if="latestFiveNews">
            <h4>Noticias</h4>

            <b-list-group>
                <b-list-group-item
                    v-for="news in latestFiveNews"
                    :key="`news-${news.id}`"
                    class="clickable"
                    @click="onDisplayDetails(news)"
                >
                    {{ news.title }}
                </b-list-group-item>
            </b-list-group>
            <hr />

            <!-- News Details Modal -->
            <NewsDetailsModal />
        </div>

        <SiteTwitterFeed
            v-if="displayTwitterFeed"
            :twitterId="getActiveSiteNewsConfig.twitterId"
            :widgetHeight="displayTwitterFeedHeight"
        />

    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SiteTwitterFeed from './SiteTwitterFeed'
import NewsDetailsModal from './subpages/SiteNews/NewsDetailsModal'

export default {
    name: 'SiteNewsDigest',
    components: {
        SiteTwitterFeed,
        NewsDetailsModal
    },
    computed: {
        ...mapState([
            'activeSite'
        ]),
        ...mapGetters([
            'getActiveSiteNewsList',
            'getActiveSiteNewsConfig'
        ]),
        latestFiveNews () {
            // return the latest 5 news
            if (this.getActiveSiteNewsList && this.$route.name !== 'site-news') {
                return this.getActiveSiteNewsList.slice(0, 5)
            }
            return null
        },
        displayTwitterFeed () {
            if (this.getActiveSiteNewsConfig) {
                if (this.getActiveSiteNewsConfig.displayTwitterFeed) {
                    return true
                }
            }
            return false
        },
        displayTwitterFeedHeight () {
            if (!this.latestFiveNews) {
            // Desired max widget height + 5 times the height of a news list group item + extra h4 + hr padding
                return 400 + 250 + 103
            } else {
                return 400 + 250 - (this.latestFiveNews.length * 50)
            }
        }
    },
    methods: {
        onDisplayDetails (newsObject) {
            this.$store.commit('SET_SELECTED_NEWS_OBJECT', newsObject)
            this.$bvModal.show('modal-details-news')
        }
    }
}
</script>

<style>
/* This rules allow the text to limit itself with ellipsis */
div#latest-news-digest div.list-group-item {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
</style>
